export default "__VITE_ASSET__B7pDYm9G__"